query getComponentSubscriptionsCountBySlug($input: GetComponentSubscriptionsCountBySlugInput!) {
  subcribedComponents: getComponentSubscriptionsCountBySlug(input: $input)
}
